import type { LcgRng } from "./lcg.js";

export type WeightedItem = {
  weight: number;
};

export function weightedPick<T extends WeightedItem>(
  items: readonly T[],
  rng: LcgRng,
): T {
  if (items.length === 0) {
    throw new Error("weightedPick: items must not be empty");
  }

  const total = items.reduce((sum, item) => sum + item.weight, 0);
  if (total <= 0) {
    throw new Error("weightedPick: total weight must be positive");
  }

  const target = Math.floor(rng.nextRandom() * total);
  let cumulative = 0;

  for (const item of items) {
    cumulative += item.weight;
    if (target < cumulative) {
      return item;
    }
  }

  return items[items.length - 1];
}
